.container {
	box-sizing: border-box;
	display: flex;
	padding: 10px;
	border-radius: 5px;
	position: absolute;
	box-shadow: var(--ds-shadow-raised, 0px 2px 2px 0px var(--adg3-color-N30));
	border-style: solid;
	flex-direction: column;
	outline: none;
}

.header {
	display: flex;
	align-items: center;
}

.headerContainer {
	display: flex;
	justify-content: space-between;
}

.icon {
	width: 16px;
	height: 16px;
	background-size: 16px 16px;
	margin-right: 5px;
	display: flex;
	flex-shrink: 0;
}

.issueLink {
	display: flex;
	flex-shrink: 0;
}

.breadcrumb {
	display: flex;
	font-size: 11px;
	margin-bottom: 10px;
}

.breadcrumbIcon {
	width: 14px;
	height: 14px;
	margin-right: 5px;
}

.dates {
	margin-top: 3px;
	font-size: 12px;
	color: var(--ds-text-subtlest, var(--adg3-color-N300));
	display: flex;
	flex-shrink: 0;
}

.innerContent {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	z-index: 1;
}

.status {
	flex-shrink: 1;
	font-size: 12px;
	min-width: 0;
}

.issueSummary {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex-grow: 1;
	display: block;
	margin-bottom: 3px;
}

.bottom {
	display: flex;
	align-content: space-between;
	justify-content: space-between;
	align-items: center;
}

.dateWrapper {
	display: flex;
	flex-direction: column;
	font-size: 11px;
	margin-right: 20px;
	margin-bottom: 5px;
}

.dateValue {
	font-weight: 600;
	color: var(--ds-text, var(--adg3-color-N800));
}
